import type { SxProps, Theme } from "@mui/material";

export const BYZ_SEARCH_ICON_COLOR = "#1E88E5";

export const BYZ_SEARCH_ICON_SIZE = 22;

export const byzSearchInputSx: SxProps<Theme> = {
  paddingBottom: 0,
  maxWidth: 200,
  "& .MuiInputAdornment-root": {
    marginLeft: 0,
    paddingLeft: 0,
    alignItems: "center",
  },
  "& .MuiInputBase-root": {
    backgroundColor: "transparent !important",
    borderRadius: 0,
    paddingBottom: 0,
    paddingLeft: 0,
    minHeight: "auto",
    alignItems: "center",
    "& .MuiInputBase-input": {
      paddingBottom: "2px",
      paddingTop: 0,
    },
  },
  "& .MuiInput-root": {
    paddingBottom: 0,
    alignItems: "center",
    "& .MuiInput-input": {
      paddingBottom: "2px",
      paddingTop: 0,
    },
  },
  "& .MuiOutlinedInput-notchedOutline": { display: "none !important" },
  "& .MuiOutlinedInput-root": {
    "& fieldset": { display: "none !important" },
    backgroundColor: "transparent !important",
    border: "none !important",
    borderBottom: "1px solid rgba(0, 0, 0, 0.42) !important",
    borderRadius: 0,
    boxShadow: "none !important",
    paddingBottom: 0,
    "&:hover": {
      borderBottom: "1px solid rgba(0, 0, 0, 0.87) !important",
      backgroundColor: "transparent !important",
    },
    "&.Mui-focused": {
      borderBottom: "2px solid !important",
      borderBottomColor: "primary.main !important",
      boxShadow: "none !important",
    },
  },
};
